class VerifyController {
   constructor($scope, $state, AppConfig, QueryAPI, badge, $sce, fancyboxService, userInfo, $filter) {
      "ngInject";
      console.log("-----------------")
      console.log($state.current.name)

      this.tranlsteFilter = $filter('translate');

      this.$scope = $scope;
      this.AppConfig = AppConfig;
      this.badge = badge;
      this.$sce = $sce;
      this.userInfo = userInfo;
      this.userInfo.setUser(this.appUser);

      $scope.loading = false;
      $scope.fancyboxOptions = fancyboxService.getOptions();
      $scope.formData = JSON.parse(localStorage.getItem('verify_dna')) || {};

      this.message = '';
      this.original = null;

      $scope.captchaUrlBase = AppConfig.server_url + '/captcha';
      $scope.captchaUrl = $scope.captchaUrlBase;
      $scope.reloadCaptcha = () => {
         $scope.captchaUrl = $scope.captchaUrlBase + '?s=' + Math.random();
      };
      $scope.verify = (verifyForm) => {

         verifyForm.$setSubmitted();

         if (!verifyForm.$valid) {
            return;
         }

         if ($scope.loading) {
            return;
         }

         $scope.loading = true;

         let self = this;
         QueryAPI.one().customPOST($scope.formData, 'verify').then(
            (original) => {
               $scope.loading = false;
               this.original = original;
               if (original.reproduction) {
                  // Comes from reproduction url
                  // Display reproduction
                  self.originalContentHtml = self.$sce.trustAsHtml(original.content + self.badge.getReproductionBadgeContent(original, original.reproduction));
               } else {
                  self.originalContentHtml = self.$sce.trustAsHtml(original.content + self.badge.getBadgeContent(original));
               }
               localStorage.setItem('verify_dna', '{}')
               $state.go('app.page.verify.result');
               window.scrollTo(0, 0)
            },
            (response) => {
               $scope.loading = false;

               if (response.data) {
                  if (typeof (response.data) == 'string') {
                     this.message = response.data;
                     window.scrollTo(0, 0)
                     $state.go('app.page.verify.error');
                  } else {

                     for (let k in response.data) {
                        if (response.data.hasOwnProperty(k)) {
                           verifyForm[k].$setValidity('server', false);
                           verifyForm[k].$error.server = response.data[k][0];
                        }
                     }

                     $scope.reloadCaptcha();
                  }
               } else {
                  window.scrollTo(0, 0)
                  $state.go('app.page.verify.error');
               }
            }
         );
      };

      this.tabs = [
         {
            name: this.tranlsteFilter('page-verify-text030'),
            click: () => {
               if ($state.is('app.page.verify.main.tsa.form'))
                  return;
               $state.go('app.page.verify.main.tsa.form');
            },
            active: $state.includes('app.page.verify.main.tsa')
         },

         {
            name: this.tranlsteFilter('page-verify-evidence'),
            click: () => {
               if ($state.is('app.page.verify.main.evidence.form'))
                  return;
               $state.go('app.page.verify.main.evidence.form');
            },
            active: $state.includes('app.page.verify.main.evidence')
         },
         {
            name: this.tranlsteFilter('page-verify-title'),
            click: () => {
               if ($state.is('app.page.verify..main.form'))
                  return;
               $state.go('app.page.verify.main.form');
            },
            active: $state.is('app.page.verify.main.form')
         },

      ];
   }

   $onDestroy() {
      console.log(this.$scope.formData)
      localStorage.setItem('verify_dna', JSON.stringify(this.$scope.formData))
   }

}

export default VerifyController;



// WEBPACK FOOTER //
// ./src/app/components/page/verify/verify.controller.js